import React, {useEffect, useState} from 'react';
import {Prompt} from 'react-router-dom';
import Dialog from '@material-ui/core/Dialog';
import PropTypes from 'prop-types';
import DialogTitle from 'components/DialogTitle/styles';
import DialogContainer from 'components/DialogContainer/styles';
import {ButtonOutline, ButtonPrimary} from 'components/buttons';
import DialogBody from 'components/DialogBody/styles';
import DialogAction from 'components/DialogAction/styles';
import DialogActions from 'components/DialogActions/styles';

const LeaveModal = ({when, message, onConfirm, navigate}) => {
  const [modalVisible, setModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState(null);
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);

  const handleBlockedNavigation = (nextLocation) => {
    if (!confirmedNavigation) {
      setModalVisible(true);
      setLastLocation(nextLocation);
      return false;
    }
    return true;
  };

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      navigate(lastLocation.pathname);
    }
  }, [confirmedNavigation, lastLocation]);

  const closeModal = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
  };

  const handleConfirmNavigationClick = () => {
    setModalVisible(false);
    setConfirmedNavigation(true);
    onConfirm();
  };

  return (
    <>
      <Prompt when={when} message={handleBlockedNavigation} />
      <Dialog open={modalVisible}>
        <DialogContainer className='DialogMd'>
          <DialogTitle className='DialogTitleMarginBottom verticalCenter'>
            {message}
          </DialogTitle>
          <DialogBody>
            <DialogActions>
              <DialogAction className='DialogActions w50'>
                <ButtonOutline onClick={closeModal}>
                  <span>Discard changes</span>
                </ButtonOutline>
              </DialogAction>
              <DialogAction className='DialogActions w50'>
                <ButtonPrimary onClick={handleConfirmNavigationClick}>
                  <span>Save changes</span>
                </ButtonPrimary>
              </DialogAction>
            </DialogActions>
          </DialogBody>
        </DialogContainer>
      </Dialog>
    </>
  );
};

LeaveModal.propTypes = {
  when: PropTypes.bool.isRequired,
  message: PropTypes.string.isRequired,
  onConfirm: PropTypes.func.isRequired,
  navigate: PropTypes.func.isRequired
};

export default LeaveModal;
